export class UrlBuilder {
    private static readonly baseHref: string = process.env.REACT_APP_BASE_URL ?? location.origin;
    public static Relative(pathname:string): UrlBuilder{
        return new UrlBuilder(UrlBuilder.baseHref).relative(pathname);
    }

    private readonly _url: URL;
    constructor(url:string) {
        this._url = new URL(url);
    }

    public relative(pathname:string){
        this._url.pathname = pathname;
        return this;
    }
    public searchParams(searchParams:any){
        for(const spEntry of new URLSearchParams(searchParams).entries())
            this._url.searchParams.set(spEntry[0], spEntry[1]);

        return this;
    }

    public get url(){
        return this._url;
    }
    public get href(){
        return this._url.href
    }
}
